import { Status } from "../../constants/enums";
import useStrings from "../../hooks/useStrings";
import StatusCell from "../DataTable/StatusCell";

export enum StatusByScreen {
    common = 0,
    screenStaff = 1,
}


const CustomStatusCell = ({ status, statusByScreen, isDetail }: { status: number, statusByScreen?: number, isDetail?: boolean; }) => {
    const strings = useStrings();
    let data: any;

    switch (statusByScreen) {
        case StatusByScreen.screenStaff:
            switch (status) {
                case Status.Active:
                    data = { icon: "done", color: "success", title: strings.Common.ACTIVED };
                    break;
                case Status.Blocked:
                    data = { icon: "lock", color: "error", title: strings.Common.LOCKED };
                    break;
                case Status.Draft:
                    data = { icon: "drafts", color: "dark", title: strings.Common.DRAFT };
                    break;
                case Status.Deleted:
                    data = { icon: "remove", color: "error", title: strings.Common.DELETED };
                    break;
                case Status.PendingInvitation:
                    data = { icon: "sync", color: "warning", title: strings.Common.PENDING_INVITATION };
                    break;
                case Status.Decline:
                    data = { icon: "block", color: "error", title: strings.Common.REJECTED };
                    break;
                default:
                    data = { icon: "clear", color: "secondary", title: strings.Common.IN_ACTIVE };
                    break;
            }
            break;
        default:
            switch (status) {
                case Status.Active:
                    data = { icon: "done", color: "success", title: strings.Common.ACTIVED };
                    break;
                default:
                    data = { icon: "clear", color: "secondary", title: strings.Common.IN_ACTIVE };
                    break;
            }
            break;
    };

    return (<StatusCell data={data} isDetail={isDetail} />)
};


CustomStatusCell.defaultProps = {
    status: Status.Inactive,
    statusByScreen: StatusByScreen.common,
}

export default CustomStatusCell;